import { Modal } from "./components/modal.js";

export interface InvitePreviewView {
  projectId: string;
  name: string;
  invitedByHandle: string;
  role: "admin" | "member";
  activeMemberCount: number;
  alreadyMember: boolean;
}

/** Shown to a signed-in visitor who arrived with an invite link. */
export function InviteAcceptDialog(props: {
  open: boolean;
  preview: InvitePreviewView | null;
  error: string | null;
  working: boolean;
  /** Set once the accept succeeded: the dialog turns into the Telegram hand-off. */
  joined: { projectName: string } | null;
  onAccept(): void;
  onDecline(): void;
  /** Opens the Telegram dialog, where the deep link is minted and drawn as a QR. */
  onConnectTelegram(): void;
}) {
  const joined = props.joined;
  return <Modal open={props.open} onClose={props.onDecline} title={joined ? "You joined" : "Project invitation"}>
    <div className="invite-accept" data-testid="invite-accept">
      {joined
        ? <div className="connect-telegram" data-testid="connect-telegram">
          <p>You joined <strong>{joined.projectName}</strong>. Your general agent is on its canvas.</p>
          <h4>Connect Telegram</h4>
          <p className="muted">Link a Telegram chat and your agents&rsquo; messages reach your phone, so you can answer a handoff without opening the dashboard.</p>
          <div className="modal-actions">
            <button type="button" className="secondary" onClick={props.onDecline}>Not now</button>
            <button type="button" className="primary" onClick={props.onConnectTelegram}>Connect Telegram</button>
          </div>
        </div>
        : <>
          {props.preview
            ? <>
              <p>You were invited to <strong>{props.preview.name}</strong> by <strong>@{props.preview.invitedByHandle}</strong> as <span className="flow-chip flow-chip-role">{props.preview.role}</span>.</p>
              <p className="muted">{props.preview.activeMemberCount} active member{props.preview.activeMemberCount === 1 ? "" : "s"}. Joining lets you chat with the project's agents and add your own; your general agent becomes your block on the canvas.</p>
              {props.preview.alreadyMember && <p className="banner">You are already a member of this project.</p>}
            </>
            : props.error ? null : <p className="muted">Checking the invitation…</p>}
          {props.error && <p className="error">{props.error}</p>}
          <div className="modal-actions">
            <button type="button" className="secondary" onClick={props.onDecline} disabled={props.working}>Not now</button>
            <button type="button" className="primary" onClick={props.onAccept} disabled={props.working || !props.preview}>{props.preview?.alreadyMember ? "Open project" : "Accept"}</button>
          </div>
        </>}
    </div>
  </Modal>;
}
